
class ProspaSteps {

    constructor(uid)
    {
        // window.console.log('Initialising steps: ', uid);

        this.easeMethod = 'power2.out';
        this.revealAnimationDuration = 0.5;
        this.hideAnimationDuration = 0.5;
        this.hideDelayAmount = 0;
        this.lengthMultiplier = 1;
        this.stepsUID = uid;
        this.scrollTrigger = window.ScrollTrigger;
        this.gsap = window.gsap;
        this.numberOfSteps = document.querySelectorAll("#steps-" + this.stepsUID + " .steps .step__text").length;
        // this.stepDOMElementHeight = document.querySelector("#steps-" + this.stepsUID + " .steps__container-row").clientHeight;
        this.stepDOMElementHeight = document.querySelector("#steps-" + this.stepsUID).clientHeight;
        this.stepsHeight = this.stepDOMElementHeight * this.numberOfSteps * this.lengthMultiplier;
        this.stepsArray = window.gsap.utils.toArray("#steps-" + this.stepsUID + " .steps__container .step__trigger");

        this.scrollTrigger = window.ScrollTrigger;
        this.gsap = window.gsap;
        this.initScrollTrigger();
    }

    getDirection(self) {
        this.direction = self.direction;
    }

    playRevealAnimation(index, direction)
    {
        // window.console.log('Showing', index + 1);

        var clickedStep = window.jQuery("#steps-" + this.stepsUID + " .steps .step__text:nth-child(" + (index + 1) + ") a");

        var gaPayload = {
            'event': clickedStep.attr('data-ga-event-scroll-trigger'),
            'eventCategory': clickedStep.attr('data-ga-event-category-scroll-trigger'),
            'eventAction': clickedStep.attr('data-ga-event-action-scroll-trigger'),
            'eventLabel': clickedStep.attr('data-ga-event-label-scroll-trigger')
        };

        if (window.dataLayer) {
            window.dataLayer.push(gaPayload);
        } else {
            window.console.log('Pushing...', gaPayload);
        }

        var revealAnimation = this.gsap.timeline({paused: true, ease: this.easeMethod });

        revealAnimation.to("#steps-" + this.stepsUID + " .step__image-" + (index + 1), { opacity: 1, duration: this.revealAnimationDuration, overwrite: true }, 0);
        revealAnimation.to("#steps-" + this.stepsUID + " .step__text-" + (index + 1) + " .step__trigger-" + (index + 1), { 'color': '#1a1a1a', duration: this.revealAnimationDuration, overwrite: true }, 0 );
        revealAnimation.to("#steps-" + this.stepsUID + " .step__text-" + (index + 1) + " .step__number-" + (index + 1), { 'color': '#1a1a1a', duration: this.revealAnimationDuration, overwrite: true }, 0 );
        revealAnimation.to("#steps-" + this.stepsUID + " .step__text-" + (index + 1) + " .accordion-collapse", { opacity: 1, height: 'auto', duration: this.revealAnimationDuration, overwrite: true }, 0);

        revealAnimation.restart().play();
    }

    playHideAnimation(index, direction)
    {
        // window.console.log('Hiding', index + 1);

        var hideAnimation = this.gsap.timeline({paused: true, ease: this.easeMethod, overwrite: true});

        hideAnimation.to("#steps-" + this.stepsUID + " .step__image-" + (index + 1), { opacity: 0, duration: this.hideAnimationDuration, overwrite: true }, 0);
        hideAnimation.to("#steps-" + this.stepsUID + " .step__text-" + (index + 1) + " .step__trigger-" + (index + 1), { 'color': 'rgba(16,49,42,.75)', duration: this.hideAnimationDuration, overwrite: true }, 0 );
        hideAnimation.to("#steps-" + this.stepsUID + " .step__text-" + (index + 1) + " .step__number-" + (index + 1), { 'color': 'rgba(16,49,42,.75)', duration: this.hideAnimationDuration, overwrite: true }, 0 );
        hideAnimation.to("#steps-" + this.stepsUID + " .step__text-" + (index + 1) + " .accordion-collapse", { opacity: 0, height: 0, duration: this.hideAnimationDuration, overwrite: true }, 0);

        hideAnimation.restart().play();
    }

    initScrollTrigger()
    {
        var classThis = this;

        this.scrollTrigger.matchMedia({

            // desktop
            "(min-width: 992px)": function () {

                var tl = classThis.gsap.timeline({});

                tl = classThis.gsap.timeline({
                    scrollTrigger: {
                        trigger: "#steps-" + classThis.stepsUID + ".steps__outer-container",
                        start: "top top",
                        end: "bottom+=" + classThis.stepsHeight + "px top",
                        scrub: true,
                        pin: true,
                        markers: false
                    }
                });

                classThis.stepsArray.forEach((section, index) => {

                    tl.add(function() {
                        if (index > 0 ) {
                            classThis.getDirection(tl.scrollTrigger);
                            if(classThis.direction > 0) {
                                classThis.playRevealAnimation(index, classThis.direction);
                            } else {
                                classThis.playHideAnimation(index, classThis.direction);
                            }
                        }
                    })

                    tl.to({}, {})

                    tl.add(function() {
                        if (index + 1 < classThis.numberOfSteps) {
                            classThis.getDirection(tl.scrollTrigger);
                            if(classThis.direction > 0) {
                                classThis.playHideAnimation(index, classThis.direction);
                            } else {
                                classThis.playRevealAnimation(index, classThis.direction);
                            }
                        }
                    });

                });

                var navList = document.querySelectorAll("#steps-" + classThis.stepsUID + " .steps .step__text");

                // Make the steps change slides when clicking on steps headings
                navList.forEach((a, i) => {
                    var st = tl.scrollTrigger;
                    var progress = i % classThis.numberOfSteps + 1;

                    a.addEventListener('click', (e) => {
                        e.preventDefault();
                        window.scrolledViaClick = true;
                        classThis.gsap.set(window, {
                            scrollTo: {
                                y: st.start + progress * (st.end - st.start) / classThis.numberOfSteps - 50,
                                smooth: false
                            }
                        });
                    });
                });

            }
        });
    }
}


export { ProspaSteps };